export default {
  gridTemplate: '1fr 1fr 1fr 1fr',
  gridColumnGap: '0.5rem',
  gridMarginRight: '0',
  formTextColor: 'var(--base-brown)',
  loanCalculatorPadding: '2.5rem',
  loanCalculatorPaddingMobile: '1.5rem',
  formPaddingTopBottom: '1.5rem',
};
